module.exports = __webpack_public_path__ + "static/media/thank-you-person.e3e40f75.svg";